<script setup lang="ts">
import { marked } from 'marked'
const { content, maxWidth = 'none' } = defineProps<{
  content: string
  maxWidth?: 'none' | 'prose'
}>()

const { $sanitizeHTML } = useNuxtApp()
const safeContent = $sanitizeHTML(content ? marked.parse(content) : '')

const proseClasses = [
  // Headings
  'prose-headings:font-semibold',
  'prose-headings:text-muted-900',
  'prose-headings:dark:text-muted-300',
  // Other text (use generic classes to let them apply to all prose content)
  'text-muted-700',
  'dark:text-muted-400',
  // Custom size
  'md:text-md17',
  // override the .nui-prose default width, which is `max-width: 65ch;`
  maxWidth != 'prose' ? 'max-w-none' : 'max-w-prose',
]
</script>

<template>
  <!-- We decided to use 17px / 1.0625rem on large screens. -->
  <!-- h1, h2, h3 tags should be darker than regular text -->
  <BaseProse :class="proseClasses">
    <!-- eslint-disable-next-line vue/no-v-html -->
    <div v-html="safeContent" />
  </BaseProse>
</template>
